import React from 'react';
import { FilterIcon } from '../../ui/Icons';

interface UserFilterBarProps {
  filter: string;
  setFilter: (value: string) => void;
  excludeFilter: boolean;
  setExcludeFilter: (value: boolean) => void;
}

export const UserFilterBar: React.FC<UserFilterBarProps> = ({ filter, setFilter, excludeFilter, setExcludeFilter }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm">
      <div className="px-2 sm:px-4 py-2 sm:py-3">
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
          <div className="flex items-center gap-1.5 flex-shrink-0">
            <FilterIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-slate-500 dark:text-slate-400" />
            <span className="text-xs sm:text-sm font-medium text-slate-700 dark:text-slate-300">Filter</span>
          </div>
          <input
            type="text"
            placeholder="Search by name or email..."
            value={filter}
            onChange={e => setFilter(e.target.value)}
            className="flex-1 w-full sm:max-w-sm px-2 sm:px-3 py-1.5 text-xs sm:text-sm border border-slate-300 dark:border-slate-600 rounded-md bg-white dark:bg-slate-800 text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
          />
          <label className="flex items-center gap-1.5 cursor-pointer flex-shrink-0">
            <input
              type="checkbox"
              className="w-3.5 h-3.5 text-emerald-600 border-slate-300 dark:border-slate-500 rounded focus:ring-emerald-500"
              checked={excludeFilter}
              onChange={e => setExcludeFilter(e.target.checked)}
            />
            <span className="text-xs sm:text-sm text-slate-600 dark:text-slate-400">Exclude</span>
          </label>
        </div>
      </div>
    </div>
  );
};
